import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import H4 from 'components/H4';
import Svg from '_assets/svg';

const Wrapper = styled.div`
    padding: 25px 20px 25px 25px;
    background: #F0F3F5;
    margin-bottom: 30px;
    border-radius: 8px;
    position: relative;
    border-left: 4px solid  #4EAC64;
`

const Img = styled.img`
    width: 24px;
    height: 24px;
`

const Divider = styled.div`
    position: absolute;
    top: 30px;
    left: -4px;
    width: 4px;
    `
const ImgInfo = styled.img`
    width: 28px;
    height: 28px;
`
const SuccessSubmit = (props) => {
    const { exit } = props;

    return (
        <Wrapper className="d-flex flex-row justify-content-between align-items-center">
            <Divider className="d-flex justify-content-center align-items-center">
                <ImgInfo src={Svg.info_outline.default} />
            </Divider>
            <H4>
                Thanks for submit your company data. Now, you can add your an application, Enjoy
                <span role="img" aria-label="emoji"> 😉</span>
            </H4>
            <button type="button" className="btn border-0" onClick={exit}>
                <Img src={Svg.clear.default} />
            </button>
        </Wrapper>
    )
}

SuccessSubmit.propTypes = {
    exit: PropTypes.func.isRequired
}

export default SuccessSubmit;